<template>
  <v-tooltip left>
    <template v-slot:activator="{ on, attrs }">
      <v-chip class="mb-3" color="accent" dark v-bind="attrs" v-on="on" @click="confirmAbandon" outlined>
        <v-icon color="accent" class="mr-2" x-small>fa-power-off</v-icon>
        {{ $t('btnText') }}
      </v-chip>
    </template>
    <h3 v-if="!canLeft" class="white-content">{{ $t('tooltipTitle') }}</h3>
    <p v-html="$t((canLeft)? 'tooltipDescriptionIfCan' : 'tooltipDescription', { days: daysLeft })" class="my-0"/>
  </v-tooltip>
</template>

<script>
export default {
  name: "AbandonButton",
  data() {
    return {
      canLeft: false,
      daysLeft: -1,
    };
  },
  mounted() {
    this.calculateDaysToAbandon();
  },
  methods: {
    calculateDaysToAbandon() {
      let abandonTime = new Date(this.$store.state.fundingTest.createdAt);
      abandonTime.setDate(abandonTime.getDate() + 3);
      let differenceInTimeTotal = abandonTime.getTime() - new Date().getTime();
      this.daysLeft = Math.floor(differenceInTimeTotal / (1000 * 3600 * 24));
      this.canLeft = this.daysLeft < 0;
    },
    confirmAbandon() {
      if(this.canLeft)
        this.$emit('confirmAbandon');
    }
  },
}
</script>

<i18n>
{
  "en": {
    "btnText": "Abandon",
    "tooltipTitle": "Do you want to abandon now? Don't give up!",
    "tooltipDescription": "A losing streak at the beginning doesn't mean that you can no longer do it.<br>There are still {days} days left to quit.",
    "tooltipDescriptionIfCan": "If you want, you can quit your<br>evaluation simulation to start another one."
  },
  "es": {
    "btnText": "Abandonar",
    "tooltipTitle": "¿Quieres abandonar ya? ¡No te rindas!",
    "tooltipDescription": "Una mala racha al inicio no significa que ya no puedas hacerlo.<br>Para abandonar faltan aún {days} días.",
    "tooltipDescriptionIfCan": "Si lo deseas, puedes abandonar tu<br>simulación de prueba para comenzar otra."
  }
}
</i18n>

<style lang="scss" scoped>
@import "src/global";

.white-content {
  color: $white-color;
}
</style>
